export default "__VITE_ASSET__6606ba27__"